import React from "react";
import Head from "next/head";
import ErrorPage from "@containers/ErrorPage";
import Promo from "@containers/Promo/index";

const PromoPage = ({ layoutProps }) => {
  const { notFound, page } = layoutProps;

  if (notFound) {
    return <ErrorPage layout="404" />;
  }

  return (
    <>
      <Head>{page && page.title && <title>{page.title}</title>}</Head>
      <Promo {...layoutProps} />
    </>
  );
};

PromoPage.pageLayout = "promo";

PromoPage.layoutProps = {
  hasLiteHeader: true,
  displaySearch: false,
  displayBackLink: true,
  skipMiniCartFetch: false,
};

export default PromoPage;
